import ApiService from '../api.service';

const QuickValueResource = {
  index: () => ApiService.get('/v1/quick_values'),
};

export default QuickValueResource;
